var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "downlinesearch-card"
  }, [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.searchDownline.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("First Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.agent_fname,
      expression: "filters.agent_fname"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter First Name"
    },
    domProps: {
      "value": _vm.filters.agent_fname
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "agent_fname", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Last Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.agent_lname,
      expression: "filters.agent_lname"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Last Name"
    },
    domProps: {
      "value": _vm.filters.agent_lname
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "agent_lname", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Rep Phone")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.agent_phone,
      expression: "filters.agent_phone"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Rep Phone"
    },
    domProps: {
      "value": _vm.filters.agent_phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "agent_phone", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Rep Email")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.agent_email,
      expression: "filters.agent_email"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "email",
      "placeholder": "Rep Email"
    },
    domProps: {
      "value": _vm.filters.agent_email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "agent_email", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Rep Code")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.agent_code,
      expression: "filters.agent_code"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Rep Code"
    },
    domProps: {
      "value": _vm.filters.agent_code
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "agent_code", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Upline Rep Code")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.upline_code,
      expression: "filters.upline_code"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Upline Rep Code"
    },
    domProps: {
      "value": _vm.filters.upline_code
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "upline_code", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Upline Rep Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.upline_name,
      expression: "filters.upline_name"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Upline Rep Name"
    },
    domProps: {
      "value": _vm.filters.upline_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "upline_name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Status")]), _c('multiselect', {
    attrs: {
      "name": "state",
      "placeholder": "Select Status",
      "options": _vm.status.map(function (type) {
        return type.value;
      }),
      "custom-label": function customLabel(opt) {
        return _vm.status.find(function (x) {
          return x.value == opt;
        }).text;
      }
    },
    model: {
      value: _vm.filters.agent_status,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "agent_status", $$v);
      },
      expression: "filters.agent_status"
    }
  })], 1)]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("State")]), _c('multiselect', {
    attrs: {
      "name": "state",
      "placeholder": "Select State",
      "options": _vm.states.map(function (type) {
        return type.value;
      }),
      "custom-label": function customLabel(opt) {
        return _vm.states.find(function (x) {
          return x.value == opt;
        }).text;
      }
    },
    model: {
      value: _vm.filters.agent_state,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "agent_state", $$v);
      },
      expression: "filters.agent_state"
    }
  })], 1), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Group")]), _c('multiselect', {
    attrs: {
      "name": "group",
      "placeholder": "Select Group",
      "options": _vm.groups.map(function (type) {
        return type.group_id;
      }),
      "custom-label": function customLabel(opt) {
        return _vm.groups.find(function (x) {
          return x.group_id == opt;
        }).group_name;
      },
      "options-limit": 100,
      "internal-search": false,
      "local-search": false
    },
    on: {
      "search-change": _vm.searchHandler,
      "open": _vm.getGroups
    },
    model: {
      value: _vm.filters.group_id,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "group_id", $$v);
      },
      expression: "filters.group_id"
    }
  })], 1), !_vm.isEnrollPrime ? _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Level")]), _c('multiselect', {
    attrs: {
      "name": "Level",
      "placeholder": "Select Level",
      "options": _vm.level_options,
      "multiple": true,
      "options-limit": 100,
      "internal-search": true,
      "local-search": true
    },
    on: {
      "search-change": _vm.searchHandler,
      "open": _vm.getGroups
    },
    model: {
      value: _vm.filters.agent_level,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "agent_level", $$v);
      },
      expression: "filters.agent_level"
    }
  })], 1) : _vm._e(), !_vm.isEnrollPrime ? _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Agent Contracts")]), _c('multiselect', {
    attrs: {
      "name": "Agent Contracts",
      "placeholder": "Select Agent Contract",
      "options": _vm.contractOptions.map(function (name) {
        return name.value;
      }),
      "options-limit": 100,
      "multiple": true,
      "internal-search": true,
      "local-search": true
    },
    model: {
      value: _vm.filters.contract,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "contract", $$v);
      },
      expression: "filters.contract"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Products")]), _c('multiselect', {
    attrs: {
      "name": "Products",
      "placeholder": "Select Product",
      "options": _vm.planOptions.map(function (plan) {
        return plan.plan_name;
      }),
      "options-limit": 100,
      "multiple": true,
      "internal-search": true,
      "local-search": true
    },
    on: {
      "search-change": _vm.searchPlan
    },
    model: {
      value: _vm.filters.product,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "product", $$v);
      },
      expression: "filters.product"
    }
  })], 1), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Business Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.business_name,
      expression: "filters.business_name"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Business Name"
    },
    domProps: {
      "value": _vm.filters.business_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "business_name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("SSN")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.agent_ssn,
      expression: "filters.agent_ssn"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter last 4 digits or full 9-digit SSN",
      "maxlength": "9",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": _vm.filters.agent_ssn
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "agent_ssn", $event.target.value);
      }, function ($event) {
        _vm.filters.agent_ssn = _vm.filters.agent_ssn.replace(/\D/g, '').slice(0, 9);
      }]
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("EIN")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.tin,
      expression: "filters.tin"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter last 4 digits or full 9-digit EIN",
      "maxlength": "9",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": _vm.filters.tin
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "tin", $event.target.value);
      }, function ($event) {
        _vm.filters.tin = _vm.filters.tin.replace(/\D/g, '').slice(0, 9);
      }]
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Routing Number")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.routing_number,
      expression: "filters.routing_number"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Routing Number",
      "maxlength": "9",
      "pattern": "\\d{9}"
    },
    domProps: {
      "value": _vm.filters.routing_number
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "routing_number", $event.target.value);
      }, function ($event) {
        _vm.filters.routing_number = _vm.filters.routing_number.replace(/\D/g, '').slice(0, 9);
      }]
    }
  }), _vm.filters.routing_number && _vm.filters.routing_number.length !== 9 ? _c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Please enter exactly 9 digits. ")]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Bank Account Number (Last 4 digits)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.account_number,
      expression: "filters.account_number"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Bank Account Number (Last 4 digits)",
      "maxlength": "4",
      "pattern": "[0-9]*"
    },
    domProps: {
      "value": _vm.filters.account_number
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "account_number", $event.target.value);
      }, function ($event) {
        _vm.filters.account_number = _vm.filters.account_number.replace(/\D/g, '').slice(0, 4);
      }]
    }
  }), _vm.filters.account_number && _vm.filters.account_number.length !== 4 ? _c('small', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" Please enter exactly 4 digits. ")]) : _vm._e()]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Account Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.account_name,
      expression: "filters.account_name"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "text",
      "placeholder": "Account Name"
    },
    domProps: {
      "value": _vm.filters.account_name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "account_name", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Rep Type")]), _c('multiselect', {
    attrs: {
      "name": "rep_type",
      "placeholder": "Select Rep Type",
      "options": _vm.repTypeOptions.map(function (t) {
        return t.value;
      }),
      "custom-label": function customLabel(opt) {
        return _vm.repTypeOptions.find(function (x) {
          return x.value == opt;
        }).text;
      }
    },
    model: {
      value: _vm.filters.rep_type,
      callback: function callback($$v) {
        _vm.$set(_vm.filters, "rep_type", $$v);
      },
      expression: "filters.rep_type"
    }
  })], 1)]), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Enrollment From")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.enrollment_from,
      expression: "filters.enrollment_from"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "date",
      "max": _vm.today
    },
    domProps: {
      "value": _vm.filters.enrollment_from
    },
    on: {
      "change": _vm.onEnrollmentFromChange,
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "enrollment_from", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4"
  }, [_c('label', [_vm._v("Enrollment To")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.enrollment_to,
      expression: "filters.enrollment_to"
    }],
    staticClass: "downlinesearch-field",
    attrs: {
      "type": "date",
      "disabled": !_vm.filters.enrollment_from,
      "min": _vm.filters.enrollment_from,
      "max": _vm.today
    },
    domProps: {
      "value": _vm.filters.enrollment_to
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.filters, "enrollment_to", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4 d-flex align-items-center",
    staticStyle: {
      "padding-top": "28px"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.non_submitted_case,
      expression: "filters.non_submitted_case"
    }],
    staticStyle: {
      "width": "18px",
      "height": "18px",
      "cursor": "pointer",
      "margin-right": "8px",
      "flex-shrink": "0"
    },
    attrs: {
      "type": "checkbox",
      "id": "non_submitted_case",
      "true-value": 1,
      "false-value": 0
    },
    domProps: {
      "checked": Array.isArray(_vm.filters.non_submitted_case) ? _vm._i(_vm.filters.non_submitted_case, null) > -1 : _vm._q(_vm.filters.non_submitted_case, 1)
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.filters.non_submitted_case,
            $$el = $event.target,
            $$c = $$el.checked ? 1 : 0;

        if (Array.isArray($$a)) {
          var $$v = null,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.filters, "non_submitted_case", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.filters, "non_submitted_case", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.filters, "non_submitted_case", $$c);
        }
      }
    }
  }), _c('label', {
    staticClass: "mb-0",
    staticStyle: {
      "cursor": "pointer",
      "font-weight": "500"
    },
    attrs: {
      "for": "non_submitted_case"
    }
  }, [_vm._v(" Non Submitted Cases ")])])])]), _c('div', {
    staticClass: "row justify-content-md-end align-items-end"
  }, [_c('div', {
    staticClass: "col-12 col-xxl-auto col-xl-auto mb-3 mb-xl-0"
  }, [_c('div', {
    staticClass: "quick-date-btns d-flex align-items-center gap-2 flex-wrap"
  }, [_c('button', {
    staticClass: "quick-date-btn",
    class: {
      active: _vm.activeQuickFilter === 'all'
    },
    attrs: {
      "type": "button",
      "title": "All reps"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'all');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-list me-1"
  }), _vm._v(" All Reps ")]), _c('button', {
    staticClass: "quick-date-btn",
    class: {
      active: _vm.activeQuickFilter === 'today'
    },
    attrs: {
      "type": "button",
      "title": "Reps signed up today"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'today');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-day me-1"
  }), _vm._v(" Reps Today ")]), _c('button', {
    staticClass: "quick-date-btn",
    class: {
      active: _vm.activeQuickFilter === 'week'
    },
    attrs: {
      "type": "button",
      "title": "Reps signed up this week"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'week');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-week me-1"
  }), _vm._v(" Reps This Week ")]), _c('button', {
    staticClass: "quick-date-btn",
    class: {
      active: _vm.activeQuickFilter === 'month'
    },
    attrs: {
      "type": "button",
      "title": "Reps signed up this month"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'month');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-alt me-1"
  }), _vm._v(" Reps This Month ")])])]), _vm._m(0), _c('div', {
    staticClass: "col-xxl-2 col-xl-3"
  }, [_c('button', {
    staticClass: "univ-btn",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.goToExportLogs
    }
  }, [_vm._v("View Export Logs")])]), _c('div', {
    staticClass: "col-xxl-2 col-xl-3"
  }, [_c('button', {
    staticClass: "univ-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportRep
    }
  }, [_c('i', {
    staticClass: "fas fa-file-export"
  }), _vm._v(" Export")])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-xxl-2 col-xl-3"
  }, [_c('button', {
    staticClass: "univ-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")])]);
}]

export { render, staticRenderFns }